/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import styles from './SensorGroup.module.css';
import strings from '../../../../globalization';

const SensorGroup = ({ sensorGroupsList, openQRCodeScanner, closePopup }) => {
  const [group, setGroup] = useState({});

  const isEmptyObject = obj => {
    return !(obj && Object.keys(obj).length !== 0 && obj.constructor === Object);
  };

  const onClickContinue = () => {
    if (!isEmptyObject(group)) {
      openQRCodeScanner && openQRCodeScanner(group);
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.close} onClick={closePopup}>X</span>
      <div className={styles.title}>{strings.sensorGroup}</div>
      <div className={styles.subTitle}>{strings.pleaseMakeASelection}</div>
      <div className={styles.contentWrapper}>
        {sensorGroupsList.map(sensorGrp =>
          <div key={`SensorGrpID-${sensorGrp.id}`}>
            <div
              key={`id-${sensorGrp.id}`}
              className={styles.sensorGrpName}
              style={{ border: sensorGrp.id === group?.id ? '0.1vh solid #ad0028' : '0.1vh solid #ffffff' }}
              onClick={() => setGroup(sensorGrp)}
            >
              {sensorGrp.name}
            </div>
          </div>
        )}
      </div>
      <Button className={styles.button} disabled={isEmptyObject(group)} onClick={onClickContinue}>
        <span className={styles.buttonText}>{strings.continue.toUpperCase()}</span>
      </Button>
    </div>
  );
};

export default SensorGroup;

SensorGroup.propTypes = {
  sensorGroupsList: PropTypes.array,
  openQRCodeScanner: PropTypes.func,
  closePopup: PropTypes.func,
};

SensorGroup.defaultProps = {
  sensorGroupsList: [],
  openQRCodeScanner: () => { },
  closePopup: () => { },
};
